"use client";

import React from "react";

//Styled
import * as S from "./styles";

//Image
import UserImage from "@/assets/images/user2.png";
import ImageDefault from "@/assets/images/image-default.png";

//Components
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import Icon from "../icon";

const Notfication = () => {
  const Notfications = [
    {
      userImage: ImageDefault,
      userName: "Sistema",
      descriptionNotfication:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      dateNotfication: "Hoje, 07:57",
    },
    {
      userImage: ImageDefault,
      userName: "Sistema",
      descriptionNotfication:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      dateNotfication: "Hoje, 07:57",
    },
    {
      userImage: ImageDefault,
      userName: "Sistema",
      descriptionNotfication:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      dateNotfication: "Hoje, 07:57",
    },
  ];

  return (
    <S.BoxNotfication>
      <S.ButtonNotfication>
        <S.AlertNotification>
          <S.Ping />
          <S.Dot />
        </S.AlertNotification>
        <Icon name="bell" />
      </S.ButtonNotfication>
      <S.NotficationContent>
        {Notfications.map((notfication, index) => (
          <DropdownMenuItem key={index}>
            <S.ButtonItemNotfication>
              <S.ImageUserNotfication src={notfication.userImage} />
              <S.ContentNotfication>
                <S.TitleNotfication>{notfication.userName}</S.TitleNotfication>
                <S.DescriptionNotfication>
                  {notfication.descriptionNotfication}
                </S.DescriptionNotfication>
                <S.DateNotfication>
                  {notfication.dateNotfication}
                </S.DateNotfication>
              </S.ContentNotfication>
            </S.ButtonItemNotfication>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <S.BoxButton>
          <S.ButtonComponent text="Ver todas" />
        </S.BoxButton>
      </S.NotficationContent>
    </S.BoxNotfication>
  );
};

export default Notfication;
